import React, { FunctionComponent, useState } from 'react';

import { Profile } from 'data/training';
import {
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Table,
  Accordion,
  AccordionSummary,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TypeTitle } from './farm-profiles';

type ProfilesTableProps = {
  profiles: Profile[];
  onPressRow: (profile: Profile) => void;
  title: string;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
};

const ProfilesTable: FunctionComponent<ProfilesTableProps> = ({
  profiles,
  onPressRow,
  title,
  expanded,
  onExpandedChange,
}) => {
  const [hoveredOverProfileId, setHoveredOverProfileId] = useState<string | undefined>(undefined);

  return (
    <Accordion expanded={expanded} onChange={(_, isExpanded) => onExpandedChange(isExpanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1c-content">
        <TypeTitle>{`${title}`}</TypeTitle>
      </AccordionSummary>
      <TableContainer style={{ display: 'flex', flex: 1 }}>
        <Table style={{ display: 'flex', flex: 1 }}>
          <TableBody style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            {profiles.map((profile) => (
              <TableRow
                key={profile.id}
                onClick={() => onPressRow(profile)}
                style={{
                  display: 'flex',
                  flex: 1,
                  ...(hoveredOverProfileId === profile.id
                    ? { backgroundColor: '#e7f0f6', cursor: 'pointer' }
                    : {}),
                }}
                onMouseEnter={() => setHoveredOverProfileId(profile.id)}
                onMouseLeave={() => setHoveredOverProfileId(undefined)}
              >
                <TableCell style={{ display: 'flex', flex: 1 }}>{profile.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Accordion>
  );
};

export default ProfilesTable;
